'use strict';

/* Controllers */
(function () {
    angular.module('pt.controllers', []);
    angular.module('pt.directives', []);
    angular.module('pt.filters', []);
    angular.module('pt.services', []);
})(); 